import React from 'react';
import { connect } from 'react-redux';

import TopRow from './topRow';
import SecondRow from './secondRow';
import ThirdRow from './thirdRow';

import ConfigPropMapService from '../../../../Shared/services/configPropMapService';
import ConfigPropId from '../../../../Shared/constants/configPropId';

import { loadCSRInfo, loadChatInfo } from '../actions/payloadActions';
import { loadCustomContent } from '../../../../CustomContent/src/app/actions/payloadActions';

class ContactUs extends React.Component {
    componentDidMount() {
        let sideHTMLId = ConfigPropMapService.getConfigPropbyId(ConfigPropId.CustomerServicePageSideHTML).value;

        this.props.getCSRInfo();
        this.props.getChatInfo();
        this.props.loadCustomContent(sideHTMLId);
    }

    getHeader(text) {
        return text && <h3 className="dynamic-vertical-header contact-us-header">{text}</h3>;
    }

    getTopRowHeaderText() {
        const placeholderTextToReplace = "[FirstName]";
        let contactUsTopHeaderText = ConfigPropMapService.getConfigPropbyId(ConfigPropId.ContactUsTopHeaderText).value;
        let usersFirstName = digitalData.userInfo.firstName;

        return usersFirstName ?
            contactUsTopHeaderText.replace(placeholderTextToReplace, usersFirstName) :
            contactUsTopHeaderText.replace(`${placeholderTextToReplace}. `, "").replace(/(, [A-Z])/g, x => x.toLowerCase());
    }

    render() {
        let contactUsTopHeaderText = this.getTopRowHeaderText();
        let contactUsMiddleHeaderText = ConfigPropMapService.getConfigPropbyId(ConfigPropId.ContactUsMiddleHeaderText).value;
        let defaultCSRRepTitle = ConfigPropMapService.getConfigPropbyId(ConfigPropId.CustomerServiceRepTitle).value;

        return (
            <div>
                <div className="col-md-12">
                    <h1 className="maintitle">Contact Us</h1>
                </div>
                <div className="col-md-12">
                    {this.getHeader(contactUsTopHeaderText)}
                    <div className="contact-us-row top-row">
                        <TopRow CSRRepTitle={defaultCSRRepTitle}/>
                    </div>
                    {this.getHeader(contactUsMiddleHeaderText)}
                    <div className="contact-us-row">
                        <SecondRow />
                    </div>
                    <div className="col-md-12 contact-us-row third-row">
                        <ThirdRow CSRRepTitle={defaultCSRRepTitle} />
                    </div>
                </div>
            </div>

        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        getChatInfo: () => dispatch(loadChatInfo()),
        getCSRInfo: () => dispatch(loadCSRInfo()),
        loadCustomContent: (e) => dispatch(loadCustomContent(e))
    };
}
export default connect(null, mapDispatchToProps)(ContactUs);